const e = "shimmer_13-5-3", n = {
  "cdr-skeleton-bone": "cdr-skeleton-bone_13-5-3",
  "cdr-skeleton-bone__shimmer": "cdr-skeleton-bone__shimmer_13-5-3",
  shimmer: e,
  "cdr-skeleton-bone--line": "cdr-skeleton-bone--line_13-5-3",
  "cdr-skeleton-bone--heading": "cdr-skeleton-bone--heading_13-5-3",
  "cdr-skeleton-bone--rectangle": "cdr-skeleton-bone--rectangle_13-5-3",
  "cdr-skeleton-bone--square": "cdr-skeleton-bone--square_13-5-3"
};
export {
  n as default,
  e as shimmer
};
